module.exports = __webpack_public_path__ + "media/trx-launching-event-23-feb-2024-final.759912b2.mp4";